import SageScreen from "kit/SageScreen";
import React from "react";
import { Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import styles from "./Addon.module.scss";

const Addon: React.FC = () => {
    return (
        <SageScreen>
            <h1>Rend A Hand Blender Addon</h1>
            <p>
                Rend A Hand offers an addon to make it even easier to upload
                your file for rendering. Instead of uploading your file through
                the Rend A Hand desktop app, you can do so directly through the
                Blender render menu.
            </p>
            <p>
                Using Rend A Hand, you can render your animation or image on all
                of your or your teams computers at once allowing you to
                drastically improve your render times.
            </p>
            <hr />
            <h3>Installation</h3>
            <Alert variant="warning">
                You must have Blender version <b>2.92.0 or higher</b> to use
                this addon. If you are using an older version of Blender, you
                can still upload your files using the desktop app.
            </Alert>
            <h5>Step 1: Download the Rend A Hand addon</h5>
            <p>
                To download the Rend A Hand addon, click on{" "}
                <a href="https://agora.anthonydito.com/addons/rendahand.zip">
                    this link
                </a>
                . This will download a <i>rendahand.zip</i> file that Blender
                can use to install the addon.
            </p>
            <h5>Step 2: Install the Rend A Hand addon</h5>
            <p>
                To install the Rend A Hand addon, open Blender preferences and
                then press the install button as shown in the image below. After
                pressing the install button, you will be presented with a file
                dialog. Select the <i>rendahand.zip</i> file you downloaded in
                step 1.
            </p>
            <img
                className={styles.descriptionImage}
                src={`${process.env.PUBLIC_URL}/rendahandinstall.png`}
            />
            <h5>Step 3: Enable the Addon</h5>
            <p>
                After the previous step, you should see something similar to the
                image below. Click on the circled checkbox to enable the Rend A
                Hand addon.
            </p>
            <img
                className={styles.descriptionImage}
                src={`${process.env.PUBLIC_URL}/rendahandenable.png`}
            />
            <h5>Step 4: Login to Rend A Hand</h5>
            <p>
                Now that we have enabled the addon, we need to login to Rend A
                Hand. If you do not have a Rend A Hand accout, you can create an
                accout <Link to="/welcome/sign-up">here</Link>. To log in, press
                the arrow beside the add on and then fill out the log in form.
                The form looks like the image below.
            </p>
            <img
                className={styles.descriptionImage}
                src={`${process.env.PUBLIC_URL}/rendahandlogin.png`}
            />
            <hr />
            <h3>Usage</h3>
            <p>
                To use the Rend A Hand addon, you can press the Render with Rend
                A Hand in the <b>Render &gt; Render with Rend A Hand</b>. That
                will open a web browser where you can configure your render job.
            </p>
            <hr />
            <h3>Questions</h3>
            <p>
                For questions or feedback, please reach out to{" "}
                <a href="mailto:info@rendahand.com">feedback@rendahand.com</a>
            </p>
        </SageScreen>
    );
};

export default Addon;
